import { useState, type ReactNode } from "react";
import { Sidebar, type SidebarNavItem } from "./Sidebar";
import { TopBar } from "./TopBar";

export interface AppShellProps {
  brandName: string;
  brandTag?: string;
  navItems: SidebarNavItem[];
  /** Sidebar altı: oturum aksiyonu gibi ikincil öğeler. */
  sidebarFooter?: ReactNode;
  /** TopBar sağı: context etiketi, kullanıcı bilgisi. */
  topBarActions?: ReactNode;
  children: ReactNode;
}

export function AppShell({
  brandName,
  brandTag,
  navItems,
  sidebarFooter,
  topBarActions,
  children,
}: AppShellProps) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="qr-shell">
      <TopBar
        brandName={brandName}
        brandTag={brandTag}
        actions={topBarActions}
        navOpen={navOpen}
        onToggleNav={() => setNavOpen((open) => !open)}
      />
      <div className="qr-shell-body">
        <Sidebar
          items={navItems}
          footer={sidebarFooter}
          open={navOpen}
          onNavigate={() => setNavOpen(false)}
        />
        {navOpen ? (
          <div
            className="qr-shell-scrim"
            aria-hidden="true"
            onClick={() => setNavOpen(false)}
          />
        ) : null}
        <main className="qr-main">
          <div className="qr-main-inner">{children}</div>
        </main>
      </div>
    </div>
  );
}
